const publicUrl = (
  typeof process !== "undefined" && process.env.PUBLIC_URL
    ? process.env.PUBLIC_URL
    : ""
).replace(/\/$/, "");
export const DATASET_PATH = `${publicUrl}/extensions_data.csv`;

export const APP_COPY = {
  title: "GitHub Actions Marketplace Insights",
  subtitle: "Executive overview of supply, demand, and verification trends",
  datasetLabel: "Loaded from CSV",
  datasetTooltip:
    "The dashboard builds on the CSV bundled with the deployment package.",
};

export const DATASET_FIELDS_LIMIT = 80;
